export const NAME = 'changePrimaryWriter';
export const LEVEL_ONE = 'ChangePrimaryWriterComponentReducer';
